// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"504":"7cbbb330","612":"fa1ef251","659":"bc26da04","896":"73c62283"}[chunkId] + ".css";
};